import { connect } from 'react-redux'
import { getApper, saveJBBuka } from './actions'
import Setting from './main'


const mapDispatchToProps = {
  getApper,
    saveJBBuka
}
const mapStateToProps = (state) => {
  return {
    ...state.JiaBanBukaEditor
  }
}
  

export default connect(mapStateToProps, mapDispatchToProps)(Setting)
